import { Modal, ModalTransition } from '@atlaskit/onboarding';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { DOMUtils, LocalStorageUtils } from '@atlassian/mpac-utils';
import React, { useEffect, useState } from 'react';
import { BodyNormal } from '../Typography';
import AetherBenefitsModalSvg from './assets/AetherBenefitsModalHero.svg';
export const ModalContent = _ref => {
  let {
    dismissModalHandler
  } = _ref;
  return /*#__PURE__*/React.createElement(Modal, {
    actions: [{
      onClick: dismissModalHandler,
      text: 'Got it'
    }],
    heading: "Say hello to a new Marketplace",
    image: AetherBenefitsModalSvg,
    key: "aether-benefits-modal"
  }, /*#__PURE__*/React.createElement(BodyNormal, null, "We've improved the discovery of apps for your team with enhanced search and updated app categories. Share your thoughts and help us improve."));
};
export const AetherBenefitsModal = () => {
  const [showModal, setShowModal] = useState(false);
  const {
    enableAetherBenefitsModal
  } = useStatsig();
  useEffect(() => {
    const isBot = DOMUtils.isCrawler(window.navigator.userAgent) || DOMUtils.isSynthetic();
    if (enableAetherBenefitsModal() && !isBot && !LocalStorageUtils.getFromStorage('displayed-aether-benefits-modal')) {
      setShowModal(true);
    }
  }, [enableAetherBenefitsModal]);
  const dismissModalHandler = () => {
    LocalStorageUtils.writeStorage('displayed-aether-benefits-modal', true);
    setShowModal(false);
  };
  return /*#__PURE__*/React.createElement(ModalTransition, null, showModal && /*#__PURE__*/React.createElement(ModalContent, {
    dismissModalHandler: dismissModalHandler
  }));
};